$(document).ready(function() {
	$('.image-popup-vertical-fit').magnificPopup({
		type: 'image',
		closeOnContentClick: true,
		mainClass: 'mfp-img-mobile',
		image: {
			verticalFit: true
		}
		
	});
    
    $('.f-multicolumn--carousel').each( function() {
        var slick = $(this),
        item =  $(this).data('columns');
        $('.f-multicolumn--carousel').slick({
            dots: false,
            infinite: true,
            arrows: true,
            swipe: true,
            swipeToSlide: true,
            slidesToShow: item,
            slidesToScroll: item,
            prevArrow: '<div class="arrow-left"><svg xmlns="http://www.w3.org/2000/svg" aria-hidden="true" focusable="false" role="presentation" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="f-icon-svg f-icon-chevron-left"><polyline points="15 18 9 12 15 6"></polyline></svg></div>',
            nextArrow: '<div class="arrow-right"><svg xmlns="http://www.w3.org/2000/svg" aria-hidden="true" focusable="false" role="presentation"  viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="f-icon-svg f-icon-chevron-right"><polyline points="9 18 15 12 9 6"></polyline></svg></div>',
            responsive: [
                {
                    breakpoint: 768,
                    settings: "unslick"
                }
            ]
        });
    });

    $('.popup-with-zoom-anim').magnificPopup({
		type: 'inline',

		fixedContentPos: false,
		fixedBgPos: true,

		overflowY: 'auto',

		closeBtnInside: true,
		preloader: false,
		
		midClick: true,
		removalDelay: 300,
		mainClass: 'my-mfp-zoom-in',

        callbacks: {
            open: function() {
                $('body').addClass('disable-scroll');
            },
            close: function() {
                $('body').removeClass('disable-scroll');
            }
        }
	});

    $('.f-section-meta-producer-press .multicolumn-card__inner').click(function(){
        $(this).find('a').get(0).click();
    });

    $('.producer-catalog__filter-label').click(function(){
        $(this).parent().find('.producer-catalog__filter-option-wrapper').toggleClass('is-visible');
    });

    $(document).on('click', function (e) {
        var $targetDiv = $('.producer-catalog__filter-bar');
        if (!$targetDiv.is(e.target) && $targetDiv.has(e.target).length === 0) {
            $targetDiv.find('.producer-catalog__filter-option-wrapper').removeClass('is-visible');
        }
    });

    $(document).on('click', '.producer-catalog__filter-apply .btn-apply', function () {
        $('.producer-catalog__filter-loading').addClass('loading');
        setTimeout(function(){
            $('.producer-catalog__filter-loading').removeClass('loading');
            $('.producer-catalog__filter-option-wrapper').removeClass('is-visible');
            const values = [];
            $('.producer-catalog__filter-input:checked').each(function () {
                values.push(this.value);
            });
            if(values.length > 0){
                $('.producer-catalog__filter + grid-list .f-grid .f-column').hide();
                $('.producer-catalog__filter + grid-list .f-grid .f-column').each(function(){
                    var info = $(this).find('.multicolumn-card__info .rte').text();
                    var match = info.match(/•\s*(.*?)\s*•/);
                    if (match) {
                        var target = match[1];
                        for(var i=0; i<values.length; i++){
                            if(target.indexOf(values[i]) > -1){
                                $(this).show();
                            }
                        }
                    }
                });
            }else{
                $('.producer-catalog__filter + grid-list .f-grid .f-column').show();
            }
        }, 500);
    });
    $(document).on('change', '.producer-catalog__filter-input', function () {
        setTimeout(function(){
            const values = [];
            $('.producer-catalog__filter-input:checked').each(function () {
                values.push(this.value);
            });
            if(values.length > 0){
                $('.producer-catalog__filter + grid-list .f-grid .f-column').hide();
                $('.producer-catalog__filter + grid-list .f-grid .f-column').each(function(){
                    var info = $(this).find('.multicolumn-card__info .rte').text();
                    var match = info.match(/•\s*(.*?)\s*•/);
                    if (match) {
                        var target = match[1];
                        for(var i=0; i<values.length; i++){
                            if(target.indexOf(values[i]) > -1){
                                $(this).show();
                            }
                        }
                    }
                });
            }else{
                $('.producer-catalog__filter + grid-list .f-grid .f-column').show();
            }
        }, 500);
    });
    $(document).on('click', '.producer-catalog__filter-apply .btn-clear', function () {
        $('.producer-catalog__filter-loading').addClass('loading');
        $('.producer-catalog__filter-input').prop('checked', false);
        setTimeout(function(){
            $('.producer-catalog__filter-loading').removeClass('loading');
            $('.producer-catalog__filter-option-wrapper').removeClass('is-visible');
            $('.producer-catalog__filter + grid-list .f-grid .f-column').show();
        }, 500);
    });
});